module.exports = __webpack_public_path__ + "img/salute.50a90406.jpg";